import { scrollToId } from "@/components/torq/scrollTo";

export function Mark({ className = "h-8 w-8" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" fill="#161614" />
      <rect x="13" y="13" width="38" height="11" fill="currentColor" />
      <path d="M26.5 24h11v28.5L32 60l-5.5-7.5V24z" fill="currentColor" />
    </svg>
  );
}

export default function Logo() {
  return (
    <a
      href="#top"
      onClick={scrollToId("top")}
      data-testid="header-logo"
      className="flex items-center group"
      aria-label="TORQ Circuit — back to top"
    >
      <img
        src="/logo-long.png"
        alt="TORQ Circuit"
        className="h-6 sm:h-7 w-auto transition-opacity duration-300 group-hover:opacity-70"
      />
    </a>
  );
}
